import mapServicesToCamelCase from 'lib/mapServicesToCamelCase.js';

const serviceInterestFields = ['procedureOfInterest', 'service', 'serviceInterest', 'serviceOfInterest', 'caseType', 'reasonForVisit'];
const locationFields = ['location', 'selectLocation'];
const servicePersonFields = ['provider', 'selectProvider', 'servicePerson'];

const getMatchedField = (formFields, fields, list, key, transformer) => {
  try {
    const values = fields.map((n) => formFields[n]).filter((n) => !!n) || [];
    const result = values //
      .map((n) => {
        let rightValue = String(n).trim().toLowerCase();
        if (transformer) {
          rightValue = transformer(rightValue);
        }
        return (list || []).find((o) => String(o[key] || '').toLowerCase() === rightValue);
      })
      .filter((n) => n !== undefined);

    return [...new Set(result)];
  } catch (e) {
    return [];
  }
};

const cleanServicePerson = (val) => {
  val = String(val);
  const cleaned = val.includes('|') ? val.split('|')[1] || '' : val;
  let parts = cleaned
    .split(' ')
    .map((n) => n.trim())
    .filter((n) => !!n);
  if (parts.length < 2) {
    return parts[0];
  }
  return `${parts[0]} ${parts[parts.length - 1]}`.trim();
};

const cleanLocation = (val) => {
  val = String(val);
  return (val.includes('|') ? val.split('|')[1] || '' : val).trim();
};

const getMatchedWebFormFields = ({ formFields, services, locations, servicePersons }) => {
  const cookedServicePersons = servicePersons.map((n) => ({ ...n, fullName: `${n.firstName || ''} ${n.lastName || ''}`.trim() }));

  return {
    serviceInterests: mapServicesToCamelCase(getMatchedField(formFields, serviceInterestFields, services, 'service_name')),
    location: getMatchedField(formFields, locationFields, locations, 'service_location_name', cleanLocation)[0],
    servicePerson: getMatchedField(formFields, servicePersonFields, cookedServicePersons, 'fullName', cleanServicePerson)[0],
  };
};

export default getMatchedWebFormFields;
